module.exports = __webpack_public_path__ + "static/media/img001.3f048f0f.jpg";